import React, { useState, useEffect } from 'react';
import SectionWrapper from './ThreeColShowcase.styles.js';
import {Image, withSitecoreContext} from '@sitecore-jss/sitecore-jss-react';

const ThreeColShowcase = ({ fields = {}, sitecoreContext }) => {
    const {
        title = {},
        copy = {},
        button = {},
        columnoneimage = {},
        columnonelink = {},
        columntwoimage = {},
        columntwolink = {},
        columnthreeimage = {},
        columnthreelink = {},
    } = fields;
    return (
        <SectionWrapper className="three-col-showcase">
            <div className="collection-showcase">
                <div className="showcase-header">
                    <div className="inner">
                        <img className="deco-img" src="//shop.bushbeans.com/cdn/shop/t/3/assets/blue-bean-top-burst.svg?v=89676103509987883181719584083"
                             alt="Bean Burst Decoration"/>
                        {!title?.value && <h2 className="main-title">Love <span>That</span> Bean Stuff</h2>}
                        {title?.value && <h2 className="main-title">{title.value}</h2>}
                    </div>
                </div>
                <div className="collections-grid">
                    <div className="collection-title-item collection-text">
                        <div className="inner">
                            <img className="deco-img"
                                 src="//shop.bushbeans.com/cdn/shop/t/3/assets/blue-bean-top-burst.svg?v=89676103509987883181719584083"
                                 alt="Bean Burst Decoration"/>
                            {!title?.value && <h2 className="main-title">Love <span>That</span> Bean Stuff</h2>}
                            {title?.value && <h2 className="main-title">{title.value}</h2>}
                            {copy?.value && <p>{copy.value}</p>}
                            <a style="margin: 15px auto 0 auto;" href="/collections/new-arrivals"
                               className="og-button-lg">Shop
                                New Arrivals</a>
                        </div>
                    </div>
                    <div className="collection-item">
                        <div className="poster">
                            {columnoneimage?.value && (
                                    <Image
                                        field={columnoneimage}
                                        className="collection-image"
                                        imageParams={{ mw: 600, mh: 600, scale: 'both' }}
                                    />
                            )}
                        </div>
                        {columnonelink && (
                            <a className="collection-link" href={columnonelink?.href}>
                                <h3>{columnonelink?.text}</h3>
                                <span>→</span>
                            </a>
                        )}
                    </div>
                    <div className="collection-item">
                        <div className="poster">
                            {columntwoimage?.value && (
                                <Image
                                    field={columntwoimage}
                                    className="collection-image"
                                    imageParams={{ mw: 600, mh: 600, scale: 'both'}}
                                />
                            )}
                        </div>
                        {columntwolink && (
                            <a className="collection-link" href={columntwolink?.href}>
                                <h3>{columntwolink?.text}</h3>
                                <span>→</span>
                            </a>
                        )}
                    </div>
                    <div className="collection-item">
                        <div className="poster">
                            {columnthreeimage?.value && (
                                <Image
                                    field={columnthreeimage}
                                    className="collection-image"
                                    imageParams={{ mw: 600, mh: 600, scale: 'both' }}
                                />
                            )}
                        </div>
                        {columnthreelink && (
                            <a className="collection-link" href={columnthreelink?.href}>
                                <h3>{columnthreelink?.text}</h3>
                                <span>→</span>
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </SectionWrapper>
    );
};

export default withSitecoreContext()(ThreeColShowcase);